var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineSun2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 12C4.75 8 8 4.75 12 4.75S19.25 8 19.25 12 16 19.25 12 19.25 4.75 16 4.75 12zm1.5 0c0 3.17 2.58 5.75 5.75 5.75s5.75-2.58 5.75-5.75S15.17 6.25 12 6.25 6.25 8.83 6.25 12zM11 22v-.08c0-.55.45-1 1-1s1 .45 1 1-.45 1.04-1 1.04-1-.41-1-.96zm7.43-2.15-.13-.13a.996.996 0 1 1 1.41-1.41l.13.13a.996.996 0 1 1-1.41 1.41zm-14.28 0a.996.996 0 0 1 0-1.41l.13-.13a.996.996 0 1 1 1.41 1.41l-.13.13a1.001 1.001 0 0 1-1.41 0zM21.92 13c-.55 0-1-.45-1-1s.45-1 1-1 1.04.45 1.04 1-.41 1-.96 1h-.08zM2 13c-.55 0-1-.45-1-1s.45-1 1-1 1.04.45 1.04 1-.41 1-.96 1H2zm16.3-7.3a.996.996 0 0 1 0-1.41l.13-.13a.996.996 0 1 1 1.41 1.41l-.13.13c-.19.19-.44.29-.7.29-.26 0-.51-.1-.71-.29zm-14.02 0-.13-.14a.996.996 0 1 1 1.41-1.41l.13.13c.39.39.39 1.02 0 1.41-.19.2-.45.3-.7.3-.26 0-.51-.1-.71-.29zM11 2.08V2c0-.55.45-1 1-1s1 .45 1 1-.45 1.04-1 1.04-1-.41-1-.96z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSun2);
export default __webpack_public_path__ + "static/media/vuesax-outline-sun_2.c68f3f034d1b80b3417401e9a5f1f548.svg";
export { ForwardRef as ReactComponent };